import param from 'jquery-param';
import { classify } from '@ember/string';
import { _getModelClass, _getModelName, _getStoreFromRecord } from './build-url';
import { isDocWithData, normalize } from 'volta/utils/api/serialize-and-push';

import type { ApiCommandOptions, ResourceApiCommand } from 'volta/utils/api/types';
import type BaseModel from 'volta/models/base-model';
import type ApplicationAdapter from 'volta/_pods/application/adapter';

export default function instanceCmd<IN = any, OUT extends VersionableModel = BaseModel>(
  cmd: string,
  options: ApiCommandOptions<IN, OUT> = {}
) {
  return function runInstanceCmd(this: OUT, payload?: IN): Promise<OUT> {
    const recordClass = _getModelClass(this);
    const modelName = _getModelName(recordClass);
    const store = _getStoreFromRecord(this);
    const adapter = store.adapterFor(modelName) as ApplicationAdapter;
    const { ajaxOptions, before, after } = options;
    const cmdPayload: ResourceApiCommand = {
      _cmd: classify(cmd),
      entityId: this.id!,
      version: this.version,
      ...(payload ?? {})
    };
    let fullUrl = adapter._buildURL(modelName);

    if (options.query) {
      fullUrl += '?' + param(options.query);
    }

    const data = (before && before.call(this, cmdPayload as IN)) ?? cmdPayload;
    return adapter
      .ajax(fullUrl, 'PATCH', Object.assign(ajaxOptions ?? {}, { data }))
      .then((response) => {
        const normalized = isDocWithData(response)
          ? (normalize(modelName, response) as OUT)
          : (response as OUT);

        if (after && !this.isDestroyed) {
          return after.call(this, cmdPayload as IN, normalized) as OUT;
        }

        return normalized;
      });
  };
}
